
export default [
  {
    "content": "A chat assistant built on the Cloudflare Agents SDK, running as a Durable Object per organization and user. Conversation history persists across sessions, streaming responses render as they arrive, and the whole thing is gated behind the paid plan as a working example of a premium feature.",
    "title": "AI chat agent",
    "date": "2026-07-21",
    "tags": [
      "ai"
    ],
    "_meta": {
      "filePath": "2026-07-21-ai-chat-agent.md",
      "fileName": "2026-07-21-ai-chat-agent.md",
      "directory": ".",
      "extension": "md",
      "path": "2026-07-21-ai-chat-agent"
    },
    "html": "<p>A chat assistant built on the Cloudflare Agents SDK, running as a Durable Object per organization and user. Conversation history persists across sessions, streaming responses render as they arrive, and the whole thing is gated behind the paid plan as a working example of a premium feature.</p>"
  },
  {
    "content": "The `onyx` command line interface, published as `@jxdltd/onyx-cli`, with an OAuth device-flow login: the CLI opens the browser, you approve the device, and no API key ever gets pasted into a terminal. Releases are automated with Changesets, so every published change lands on npm without manual steps.",
    "title": "CLI with browser login",
    "date": "2026-07-21",
    "tags": [
      "cli"
    ],
    "_meta": {
      "filePath": "2026-07-21-cli-device-login.md",
      "fileName": "2026-07-21-cli-device-login.md",
      "directory": ".",
      "extension": "md",
      "path": "2026-07-21-cli-device-login"
    },
    "html": "<p>The <code>onyx</code> command line interface, published as <code>@jxdltd/onyx-cli</code>, with an OAuth device-flow login: the CLI opens the browser, you approve the device, and no API key ever gets pasted into a terminal. Releases are automated with Changesets, so every published change lands on npm without manual steps.</p>"
  },
  {
    "content": "File storage on R2 with profile photo uploads, plus the realtime layer: a shared task list with live updates, a collaborative notes editor on Yjs, and per-page presence showing who's looking at what. Every page shares one WebSocket room through a Durable Object.",
    "title": "File uploads, realtime tasks, and collaborative notes",
    "date": "2026-07-21",
    "tags": [
      "storage",
      "realtime"
    ],
    "_meta": {
      "filePath": "2026-07-21-files-and-realtime.md",
      "fileName": "2026-07-21-files-and-realtime.md",
      "directory": ".",
      "extension": "md",
      "path": "2026-07-21-files-and-realtime"
    },
    "html": "<p>File storage on R2 with profile photo uploads, plus the realtime layer: a shared task list with live updates, a collaborative notes editor on Yjs, and per-page presence showing who's looking at what. Every page shares one WebSocket room through a Durable Object.</p>"
  },
  {
    "content": "Complete email flows for authentication: verification on sign-up and a password reset journey, delivered with React Email templates through Resend. In local development without a Resend key, emails log to the console with their action links so the flows stay testable.",
    "title": "Password reset and email verification",
    "date": "2026-07-22",
    "tags": [
      "auth"
    ],
    "_meta": {
      "filePath": "2026-07-22-auth-email-flows.md",
      "fileName": "2026-07-22-auth-email-flows.md",
      "directory": ".",
      "extension": "md",
      "path": "2026-07-22-auth-email-flows"
    },
    "html": "<p>Complete email flows for authentication: verification on sign-up and a password reset journey, delivered with React Email templates through Resend. In local development without a Resend key, emails log to the console with their action links so the flows stay testable.</p>"
  },
  {
    "content": "Three kinds of background work on Cloudflare primitives: scheduled jobs on Cron Triggers, typed queue-backed jobs with a dead-letter queue, and durable multi-step workflows. Crons and workflows register in code and merge into the Worker config at build time, so adding one never means editing deployment config in a second place.",
    "title": "Crons, background jobs, and workflows",
    "date": "2026-07-22",
    "tags": [
      "jobs"
    ],
    "_meta": {
      "filePath": "2026-07-22-background-work.md",
      "fileName": "2026-07-22-background-work.md",
      "directory": ".",
      "extension": "md",
      "path": "2026-07-22-background-work"
    },
    "html": "<p>Three kinds of background work on Cloudflare primitives: scheduled jobs on Cron Triggers, typed queue-backed jobs with a dead-letter queue, and durable multi-step workflows. Crons and workflows register in code and merge into the Worker config at build time, so adding one never means editing deployment config in a second place.</p>"
  },
  {
    "content": "A documentation site on Fumadocs and TanStack Start, deployed as its own Worker at [onyx-docs.jxd.dev](https://onyx-docs.jxd.dev). It includes guides for every package and an OpenAPI reference generated from the real API contract, so the reference can't drift from the implementation.",
    "title": "Documentation site",
    "date": "2026-07-22",
    "tags": [
      "docs"
    ],
    "_meta": {
      "filePath": "2026-07-22-documentation-site.md",
      "fileName": "2026-07-22-documentation-site.md",
      "directory": ".",
      "extension": "md",
      "path": "2026-07-22-documentation-site"
    },
    "html": "<p>A documentation site on Fumadocs and TanStack Start, deployed as its own Worker at <a href=\"https://onyx-docs.jxd.dev\">onyx-docs.jxd.dev</a>. It includes guides for every package and an OpenAPI reference generated from the real API contract, so the reference can't drift from the implementation.</p>"
  },
  {
    "content": "Typed notifications on Cloudflare primitives: an in-app feed with realtime updates through a Durable Object hub, plus batched email digests for anything left unread. Notification preferences live in settings, and the whole pipeline runs locally under `vp dev`.",
    "title": "In-app notifications and email digests",
    "date": "2026-07-22",
    "tags": [
      "notifications"
    ],
    "_meta": {
      "filePath": "2026-07-22-notifications.md",
      "fileName": "2026-07-22-notifications.md",
      "directory": ".",
      "extension": "md",
      "path": "2026-07-22-notifications"
    },
    "html": "<p>Typed notifications on Cloudflare primitives: an in-app feed with realtime updates through a Durable Object hub, plus batched email digests for anything left unread. Notification preferences live in settings, and the whole pipeline runs locally under <code>vp dev</code>.</p>"
  },
  {
    "content": "A public REST API defined contract-first with oRPC and Zod, authenticated with organization-scoped API keys in the `x-api-key` header. The contract generates an OpenAPI document and `@jxdltd/onyx-client`, a typed client published to npm, so consumers get the same types the server compiles against. CI also gained bundle-size budgets with an on-demand analyzer.",
    "title": "Public API with a typed client",
    "date": "2026-07-22",
    "tags": [
      "api"
    ],
    "_meta": {
      "filePath": "2026-07-22-public-api-and-client.md",
      "fileName": "2026-07-22-public-api-and-client.md",
      "directory": ".",
      "extension": "md",
      "path": "2026-07-22-public-api-and-client"
    },
    "html": "<p>A public REST API defined contract-first with oRPC and Zod, authenticated with organization-scoped API keys in the <code>x-api-key</code> header. The contract generates an OpenAPI document and <code>@jxdltd/onyx-client</code>, a typed client published to npm, so consumers get the same types the server compiles against. CI also gained bundle-size budgets with an on-demand analyzer.</p>"
  },
  {
    "content": "Stripe subscriptions per organization: a free plan and a paid plan billed per seat, with the plan catalog and guards in `@repo/billing`. Limits and feature gates are enforced in the UI, in server functions, and in the public API, seat quantities sync automatically as members change, and cancellation runs through the Stripe customer portal. Without Stripe keys configured, checkout is disabled but every guard still works.",
    "title": "Organization billing with Stripe",
    "date": "2026-07-23",
    "tags": [
      "billing"
    ],
    "_meta": {
      "filePath": "2026-07-23-organization-billing.md",
      "fileName": "2026-07-23-organization-billing.md",
      "directory": ".",
      "extension": "md",
      "path": "2026-07-23-organization-billing"
    },
    "html": "<p>Stripe subscriptions per organization: a free plan and a paid plan billed per seat, with the plan catalog and guards in <code>@repo/billing</code>. Limits and feature gates are enforced in the UI, in server functions, and in the public API, seat quantities sync automatically as members change, and cancellation runs through the Stripe customer portal. Without Stripe keys configured, checkout is disabled but every guard still works.</p>"
  }
]